import Vue from "vue";
import Router from "vue-router";
const _import = require("./_import_" + process.env.NODE_ENV);

const Index = _import("components/Index"); // 公共主站
const yn = _import("components/product/yn"); // C07越南
const pwaIndex = _import("components/pwa/Index"); // pwa公共主站
const multiIndex = _import("components/multiIndex"); // 公共主站
const bkIndex = _import("components/bkIndex"); // 公共主站
const oldVersionList = _import("components/oldVersionList");
const oldVersionInfo = _import("components/oldVersionInfo");

const tabSignIndex = _import("components/tabSignIndex");

Vue.use(Router);

export default new Router({
  routes: [
    {
      path:"/",
      redirect:"/Index"
    },
    {
      path: "/Index",
      name: "Index",
      component: Index
    },
    {
      path: "/oldVersionList",
      name: "oldVersionList",
      component: oldVersionList
    },
    {
      path: "/oldVersionInfo",
      name: "oldVersionInfo",
      component: oldVersionInfo
    },
    {
      path: "/yn",
      name: "yn",
      component: yn
    },
    {
      path: "/pwaIndex",
      name: "pwaIndex",
      component: pwaIndex
    },
    {
      path: "/tabSign",
      name: "tabSignIndex",
      component: tabSignIndex
    },
    {
      path: "/multiIndex",
      name: "multiIndex",
      component: multiIndex
    },
    {
      path: "/bkIndex",
      name: "bkIndex",
      component: bkIndex
    },
    
    {
      path: "/test",
      name: "test",
      component: ()=>import('@/components/test.vue')
    },
    {
      path:"/line",
      component:()=>import('@/components/line.vue')
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js